const EVENT_STATUS_COLORS = {
  urgent: "rgba(229, 57, 53, 1)",
  upcoming: "rgba(30, 136, 229, 1)",
  done: "rgba(76, 175, 80, 1)",
  pending: "rgba(235, 156, 38, 1)",
};

export default function AppointmentEvent({ appointment, onClick }) {
  const { location, status, resource, address } = appointment;
  const background = EVENT_STATUS_COLORS[status];

  return (
    <div
      className="AppointmentEvent"
      onClick={onClick}
      style={{
        background,
      }}
    >
      <p className="AppointmentEvent-p">{resource}</p>
    </div>
  );
}
